import { useEffect, useRef } from "react";
import { TextB, TextItalic, TextHOne, TextHTwo, ListBullets, ListNumbers, LinkSimple, TextAlignLeft, TextAlignCenter } from "@phosphor-icons/react";

// Lightweight rich-text editor (contentEditable). Emits HTML via onChange.
export default function RichText({ value, onChange, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current !== document.activeElement && (value || "") !== ref.current.innerHTML) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);
  const exec = (cmd, arg = null) => { ref.current?.focus(); document.execCommand(cmd, false, arg); onChange(ref.current.innerHTML); };
  const link = () => { const url = window.prompt("URL del enlace:"); if (url) exec("createLink", url); };
  const Btn = ({ onClick, children, title }) => <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); onClick(); }} className="h-8 w-8 flex items-center justify-center rounded hover:bg-white/10 text-neutral-300">{children}</button>;
  return (
    <div className="rounded-lg border border-white/15 bg-white/5 overflow-hidden" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-0.5 border-b border-white/10 px-1.5 py-1 bg-black/20">
        <Btn title="Negrita" onClick={() => exec("bold")}><TextB size={15} weight="bold" /></Btn>
        <Btn title="Cursiva" onClick={() => exec("italic")}><TextItalic size={15} /></Btn>
        <Btn title="Título" onClick={() => exec("formatBlock", "<h2>")}><TextHTwo size={15} /></Btn>
        <Btn title="Subtítulo" onClick={() => exec("formatBlock", "<h3>")}><TextHOne size={15} /></Btn>
        <Btn title="Lista con viñetas" onClick={() => exec("insertUnorderedList")}><ListBullets size={15} /></Btn>
        <Btn title="Lista numerada" onClick={() => exec("insertOrderedList")}><ListNumbers size={15} /></Btn>
        <Btn title="Alinear izquierda" onClick={() => exec("justifyLeft")}><TextAlignLeft size={15} /></Btn>
        <Btn title="Centrar" onClick={() => exec("justifyCenter")}><TextAlignCenter size={15} /></Btn>
        <Btn title="Enlace" onClick={link}><LinkSimple size={15} /></Btn>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(ref.current.innerHTML)}
        onBlur={() => onChange(ref.current.innerHTML)}
        className="min-h-[180px] max-h-[360px] overflow-y-auto px-3 py-2 text-sm text-neutral-100 outline-none leading-relaxed [&_h2]:text-xl [&_h2]:font-bold [&_h3]:text-lg [&_h3]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:underline [&_a]:text-gold"
        data-testid={testid ? `${testid}-area` : undefined}
      />
    </div>
  );
}
